import * as React from 'react';

import classNames from 'classnames';

import { IconLogoGameClub } from '@base/assets/icons';
import { Icon } from '@base/components';
import { URLS } from '@base/constants';

import { Link } from '@ui/Link';

import { ILogoProps } from './types';

import s from './Logo.scss';

export const LogoTwa = (props: ILogoProps) => {
	const { className, src } = props;

	return (
		<Link to={URLS.APPS} className={classNames(s.logo, className)}>
			{src
				? <img className={s.logoIcon} src={src} />
				: <Icon className={s.logoIcon} glyph={IconLogoGameClub}/>}
		</Link>
	);
};
